import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import Ethos from "./components/Ethos";
import Collection from "./components/Collection";
import Journey from "./components/Journey";
import Principles from "./components/Principles";
import Testimonial from "./components/Testimonial";
import CTA from "./components/CTA";

export default function Home() {
  useSmoothScroll();

  return (
    <div className="min-h-screen bg-bone text-ink">
      <Navbar />
      <main>
        <Hero />
        <Ethos />
        <Collection />
        <Journey />
        <Principles />
        <Testimonial />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}